import axiosInstance from "../Interceptor";

export const getCustomerVouchersApplyApi = (payload) => {
  // console.log(payload);
  return axiosInstance
    .get(`inventory-service/api/v1/vouchers/${payload}/`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};
